import { PlatformCoreUserFilterData } from '../types';

const initialPlatformCoreUserFilterData: PlatformCoreUserFilterData = {
    query: '',
    teams: [],
    isShutdownCoreUsersVisible: undefined,
};

export default initialPlatformCoreUserFilterData;
